import * as React from 'react';
import { useDispatch } from 'react-redux';
import { fetchApi, makeResetCache, notifyError, notifyResponse } from 'gossamer-front-end';
import { EventCoHost, EventHostView, UserRemoveCoHostRequest } from 'cb-model';
import { Button } from 'react-bootstrap';

export interface RemoveCoHostButtonProps {
  value: string;
}

export const RemoveCoHostButton: React.FC<RemoveCoHostButtonProps> = (props) => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  const handleClick = async () => {
    try {
      const payload: UserRemoveCoHostRequest = {
        eventCoHostId: Number(props.value),
      };
      const response = await fetchApi('POST', `/main/remove-co-host`, payload);
      resetCache(EventCoHost.id);
      resetCache(EventHostView.id);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while removing the co-host');
    }
  };
  return (
    <Button size="sm" variant="danger" onClick={handleClick}>
      Remove
    </Button>
  );
};
